import ipRangeCheck from 'ip-range-check';
import googlebot from '../consts/googlebot.json';
import specialCrawlers from '../consts/special-crawlers.json';
import userTriggeredFetchers from '../consts/user-triggered-fetchers.json';

const googleIpList: string[] = [
  ...googlebot.prefixes,
  ...specialCrawlers.prefixes,
  ...userTriggeredFetchers.prefixes,
].map((item: object) => Object.values(item)[0]);

export const isCrawler = (
  user_agent: string,
  ip_address?: string
): boolean | null => {
  // 1. Check if user-agent header is containing crawler-like string.
  if (
    !user_agent ||
    /bot|googlebot|crawler|spider|robot|crawling|lighthouse/i.test(user_agent)
  ) {
    return true;
  }

  if (!ip_address) return null;

  // 2. If no, then check based on ip range from Google.
  return ipRangeCheck(ip_address, googleIpList);
};
